import { isRef as r, unref as h } from "vue";
function m(n, t, s) {
  const i = n.value.$getRecord(), [u, $] = o(i, t.value, n.value);
  console.log(`diff ${s || ""} =>`), console.log(`* record:
	`, JSON.stringify(i)), console.log(`* current:
	`, JSON.stringify(t.value)), console.log("* delta:", u.length ? `
	` + u.join(`
	`) : "empty"), console.log("* dirty:", $.length ? `
	` + $.join(`
	`) : "empty"), console.log(`* validation:
	`, g(n.value));
}
function o(n, t, s, i = "") {
  const u = [], $ = [];
  for (const e of Object.keys(n))
    if (typeof n[e] != "function") {
      if (!t || t[e] === void 0)
        u.push(`diff no items ${i}.${e}`);
      else if (Array.isArray(n[e])) {
        n[e].length !== t[e].length && u.push(`diff ${i}.${e}.length: ${n[e].length} ${t[e].length}`);
        for (let f = 0; f < n[e].length; f += 1)
          if (n[e][f] === void 0)
            u.push(`diff new items ${i}.${e}.${f}: ${JSON.stringify(t[e][f])}`);
          else if (!s)
            u.push(`diff no validation items ${i}.${e}.${f}`);
          else {
            const [l, c] = o(n[e][f], t[e][f], s[e].$each[f], `${i}.${e}.${f}`);
            u.push(...l), $.push(...c);
          }
      } else if (typeof n[e] == "object")
        if (s.$each) {
          const [f, l] = o(n[e], t[e], s.$each[e], `${i}.${e}`);
          u.push(...f), $.push(...l);
        } else {
          const [f, l] = o(n[e], t[e], s[e], `${i}.${e}`);
          u.push(...f), $.push(...l);
        }
      else (!t || n[e] !== t[e]) && (u.push(`diff ${i}.${e}: ${JSON.stringify(n[e])} => ${JSON.stringify(t[e])}`), s[e].$dirty || console.warn("dirty seems to be not detected", i));
      s[e].$dirty === !0 && $.push(`${s[e].$path} ${JSON.stringify(s[e].$getRecord())} ${JSON.stringify(s[e].$model)}`);
    }
  return [u, $];
}
function g(n) {
  const t = r(n) ? h(n) : n;
  return t !== null && typeof t == "object" ? Array.isArray(t) ? t.map((s) => y(s)) : p(t) : t;
}
function y(n) {
  return n !== null && !r(n) && typeof n == "object" ? g(n) : h(n);
}
function p(n) {
  return Object.keys(n).reduce(
    (t, s) => (t[s] = y(n[s]), t),
    {}
  );
}
export {
  m as printDiff
};
//# sourceMappingURL=vuelidate.dev-DBT9xUz0.js.map
